export default "__VITE_ASSET__B6lHYdGp__"